type Props = {
  children: React.ReactNode;
};

const ErrorComponent = ({ children }: Props) => {
  return (
    <div className="d-flex justify-content-center h-100 align-items-center">
      <div className="text-center">{children}</div>
    </div>
  );
};

export default ErrorComponent;
